import type * as React from 'react';

function SvgFacebook(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" width="1em" {...props}>
      <path
        d="M20 40a20 20 0 110-40 20 20 0 010 40zm6.4-27.4V9h-3c-3 0-5 1.8-5 5.1V17H15v3.9h3.4v10h4v-10h3.8V17h-3.8v-2.5c0-1.1.3-1.9 1.9-1.9h2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgFacebook;
